module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-18.539a39c7.png";